import { BrowserRouter, Routes, Route } from 'react-router';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import AddProjectForm from "./components/AddProjectForm";
import AddPlotsForm from "./components/AddPlotsForm";
import ProjectPlotViewer from './components/ProjectPlotViewer';
import MapViewer from './components/MapViewer';
import Register from './pages/Register';
//import { Browser } from "leaflet";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login />}> </Route>
          <Route path='/register' element={<Register />}> </Route>
          <Route path='/dashboard' element={<Dashboard />}> </Route>
          <Route path="/map/:projectId" element={<MapViewer />} />
          <Route path='/project-plot-viewer' element={<ProjectPlotViewer />}> </Route>
          <Route path='/add-project' element={<AddProjectForm />}> </Route>
          <Route path='/add-plots' element={<AddPlotsForm />}> </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
